import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Pipe({ name: 'humanizeFormMessages' })
export class HumanizeFormMessagesPipe implements PipeTransform {
  transform(validationErrors: ValidationErrors) {
    if (validationErrors) {
      const keys = Object.keys(validationErrors);
      return validationErrors[keys[0]].message;
    }
  }
}
